<script setup>
</script>
<template>
  <section id="about" class="about-section">
    <h2>About Us</h2>

    <div class="about-content">
      <p>
        Welcome to <strong>Bumblefox Uk</strong>, Were a small familiy business. We love printing fantastic art, gits
        and ornaments from our favourite designers, chosen and tested by our top product researchers Ciri and Sammy!
      </p>
    </div>

    <div class="product-researchers">
      <img src="../assets/ciri.jpg" class="about-image" />
      <img src="../assets/sammy.jpg" class="about-image" />
    </div>
  </section>
</template>

<style scoped>
.about-section {
  background-color: #fff3e4;
  padding: 40px 20px;
}

.about-section h2 {
  color: #2e2d61;
  margin-bottom: 30px;
  text-align: center;
}

.about-content {
  text-align: justify;
  margin: 0 auto 30px;
  padding: 20px;
  line-height: 1.6;
  max-width: 800px;
  font-size: 1rem;
}

.about-content p {
  margin: 0;
}

.product-researchers {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  margin-top: 40px;
}

.about-image {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease;
}

.about-image:hover {
  transform: scale(1.05);
}
</style>

